webpackJsonp([1],{

/***/ 102:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pageHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return winWidth; });
/* unused harmony export winHeight */
/* unused harmony export hasBodyClass */
/* unused harmony export addRemBodyClass */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addBodyClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return removeBodyClass; });
/* unused harmony export swapBodyClass */
/* unused harmony export expandImagePath */
/* unused harmony export expandFilePath */
/* unused harmony export expandImageSize */
/* unused harmony export expandImageOrig */
/* unused harmony export cleanString */
/* unused harmony export get */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isDarkMode; });
var pageHeight = function pageHeight() {
  var B = document.body;
  var H = document.documentElement;
  return Math.max(B.scrollHeight, B.offsetHeight, H.clientHeight, H.scrollHeight, H.offsetHeight);
};

var winWidth = function winWidth() {
  if (document.documentElement && document.documentElement.clientWidth) {
    return document.documentElement.clientWidth;
  }
  if (document.body) {
    return document.body.clientWidth;
  }
};

var winHeight = function winHeight() {
  if (document.documentElement && document.documentElement.clientHeight) {
    return document.documentElement.clientHeight;
  }
  if (document.body) {
    return document.body.clientHeight;
  }
};

var hasBodyClass = function hasBodyClass(className) {
  var cl = document.body.classList;
  return cl.contains(className);
};

var addRemBodyClass = function addRemBodyClass(className, remove) {
  var cl = document.body.classList,
      hasClass = cl.contains(className);
  if (remove === false) {
    if (hasClass) {
      cl.remove(className);
    }
  } else {
    if (!hasClass) {
      cl.add(className);
    }
  }
  return cl;
};

var addBodyClass = function addBodyClass(className) {
  return addRemBodyClass(className, true);
};

var removeBodyClass = function removeBodyClass(className) {
  return addRemBodyClass(className, false);
};

var swapBodyClass = function swapBodyClass(classNameRem, classNameAdd) {
  removeBodyClass(classNameRem);
  return addBodyClass(classNameAdd);
};

var expandImagePath = function expandImagePath(src, key) {
  if (src.indexOf('/files/') < 0) {
    switch (key) {
      case 'orig':
        return '/files/' + src;
      default:
        return '/files/styles/' + key + '/public/' + src;
    }
  }
  return src;
};

var expandFilePath = function expandFilePath(path) {
  return expandImagePath(src, 'orig');
};

var expandImageSize = function expandImageSize(sizes, key) {
  if (sizes instanceof Object && sizes !== null) {
    if (sizes.hasOwnProperty(key)) {
      return expandImagePath(sizes[key], key);
    }
  }
};

var expandImageOrig = function expandImageOrig(sizes, key) {
  return expandImageSize(sizes, 'orig');
};

var cleanString = function cleanString(str) {
  return str.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-');
};

var get = function get(path) {
  return document.querySelector(path);
};

var getCookie = function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
};

var setCookie = function setCookie(name, value, days) {
  var d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
};

var isDarkMode = function isDarkMode() {
  if (window.matchMedia) {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  } else {
    var hr = new Date().getHours();
    return hr > 21 || hr < 6;
  }
};

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Home__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/*',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home___default.a
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(83)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(92),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Contact__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CookieCompliance__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CookieCompliance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CookieCompliance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TopIcons__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TopIcons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_TopIcons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MainLogo__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MainLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_MainLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils__ = __webpack_require__(15);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: {
    TopIcons: __WEBPACK_IMPORTED_MODULE_4__components_TopIcons___default.a,
    MainLogo: __WEBPACK_IMPORTED_MODULE_5__components_MainLogo___default.a,
    Contact: __WEBPACK_IMPORTED_MODULE_2__components_Contact___default.a,
    CookieCompliance: __WEBPACK_IMPORTED_MODULE_3__components_CookieCompliance___default.a
  },
  data: function data() {
    return {
      extraClasses: ["bg-1"],
      logoClass: "simple",
      logoAnim: null,
      ts: 0,
      title: "Multifaceted Web Services",
      slogan: "Building applications for a connected world",
      items: [],
      winWidth: 0,
      winHeight: 0,
      pageHeight: 0,
      halfY: 0,
      stopY: 0,
      scrolling: false,
      showContactPane: false,
      displayMode: "light",
      mayStore: true,
      footer: ""
    };
  },
  created: function created() {
    var _this = this;

    if (typeof window.location.pathname === "string") {
      var pathname = window.location.pathname;

      if (pathname === "/index.php") {
        var title = document.querySelector("title").textContent;
        history.replaceState({ page: "home" }, title, "/");
      }
    }
    this.loadContent();
    this.updatePageTitle();
    this.detectScheme();
    setTimeout(function () {
      if (SVGMorpheus) {
        _this.logoAnim = new SVGMorpheus("#main-logo");
        setTimeout(function () {
          _this.logoAnim.to("logo_full", { duration: 3000, easing: "linear", rotation: "none" }, null);
          _this.logoClass = "full";
          if (_this.winWidth < 750) {
            setTimeout(function () {
              _this.logoAnim.to("logo_simple", { duration: 2000, easing: "linear", rotation: "none" }, null);
              _this.logoClass = "simple";
            }, 6000);
          }
        }, 2000);
      }
    }, 1000);
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("keydown", function (e) {
      switch (e.which) {
        case 27:
          _this.$emit("escape", true);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["a" /* removeBodyClass */])("show-contact-pane");
          _this.showContactPane = false;
          break;
      }
    });
  },
  watch: {
    title: function title(cv, pv) {
      if (cv !== pv) {
        this.updatePageTitle();
      }
    },
    showContactPane: function showContactPane(cv, pv) {
      if (cv !== pv) {
        if (cv === true) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["b" /* addBodyClass */])("show-contact-pane");
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["a" /* removeBodyClass */])("show-contact-pane");
        }
      }
    }
  },
  computed: {
    ratio: function ratio() {
      return this.winWidth / this.winHeight;
    },
    classNames: function classNames() {
      var cls = this.extraClasses.filter(function (c) {
        return c !== "clone";
      });
      if (this.ratio > 1.6) {
        cls.push("ultra-wide");
      }
      if (this.ratio > 1.15) {
        cls.push("landscape");
      } else if (this.ratio > 0.85) {
        cls.push("square");
      }
      if (this.ratio <= 0.85) {
        cls.push("portrait");
      }
      if (this.ratio <= 0.625) {
        cls.push("ultra-tall");
      }
      return cls;
    }
  },
  methods: {
    loadContent: function loadContent(reload) {
      var _this2 = this;

      var data = this.$ls.get("all-panes", null);
      if (reload !== true && data instanceof Object && data.valid) {
        this.updateSiteData(data);
      } else {
        var backUrl = "/static/data/page-sections.json";
        this.$http.get(backUrl).then(function (response) {
          if (response.data) {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(response.data) === "object") {
              if (response.data instanceof Object) {
                if (response.data.valid) {
                  if (_this2.mayStore) {
                    _this2.$ls.set("all-panes", response.data, 24 * 60 * 60 * 1000);
                  }
                  _this2.updateSiteData(response.data);
                  var ts = response.data.ts;

                  var currTs = new Date().getTime() / 1000;
                  var secsAgo = currTs - ts;
                  if (secsAgo < 24 * 60 * 60) {
                    _this2.updateJsonSource();
                  }
                }
              }
            }
          }
        }, function (error) {
          console.log(error);
        });
      }
    },
    updateSiteData: function updateSiteData(data) {
      if (data.ts) {
        this.ts = data.ts;
      }
      if (data.title) {
        this.title = data.title;
        if (data.slogan) {
          this.slogan = data.slogan;
        }
      }
      if (data.footer) {
        this.footer = data.footer;
      }
      if (data.items instanceof Array) {
        this.items = data.items;
      }
    },
    updatePageTitle: function updatePageTitle() {
      var t = document.getElementsByTagName("title");
      if (t.length > 0) {
        t[0].innerHTML = this.title;
      }
    },
    updateJsonSource: function updateJsonSource() {
      this.$http.get("/backend-fetch.php").then(function (data) {
        if (data.valid) {
          console.log("updated");
        }
      }).catch(function (e) {
        console.error(e);
      });
    },
    reload: function reload() {
      this.loadContent(true);
    },
    topAnim: function topAnim() {
      var _this3 = this;

      if (SVGMorpheus) {
        if (this.logoAnim) {
          this.logoAnim.to("logo_simple", { duration: 2000, easing: "linear", rotation: "none" }, null);
          this.logoClass = "simple";
          setTimeout(function () {
            _this3.logoAnim.to("logo_full", { duration: 3000, easing: "linear", rotation: "none" }, null);
            _this3.logoClass = "full";
            if (_this3.winWidth < 750) {
              setTimeout(function () {
                _this3.logoAnim.to("logo_simple", { duration: 2000, easing: "linear", rotation: "none" }, null);
                _this3.logoClass = "simple";
              }, 4000);
            }
          }, 5000);
        }
      }
    },
    scrollTo: function scrollTo(selector, offset, ms) {
      var _this4 = this;

      if (!this.scrolling) {
        this.scrolling = true;
        __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default.a.scrollTo(selector, ms, {
          container: "body",
          offset: offset,
          easing: "ease-in",
          cancelable: false
        });
      }
      setTimeout(function () {
        _this4.scrolling = false;
      }, 1200);
    },
    handleResize: function handleResize(init) {
      this.pageHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["c" /* pageHeight */])();
      this.winHeight = window.innerHeight;
      this.winWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["d" /* winWidth */])();
      this.stopY = this.winHeight / 64;
      this.halfY = this.winHeight / 2;
      if (init !== true) {
        if (this.winWidth < 750 && this.logoClass !== "simple") {
          this.logoAnim.to("logo_simple", { duration: 2000, easing: "linear", rotation: "none" }, null);
          this.logoClass = "simple";
        } else if (this.winWidth >= 750 && this.logoClass !== "full") {
          this.logoAnim.to("logo_full", { duration: 2000, easing: "linear", rotation: "none" }, null);
          this.logoClass = "full";
        }
      }
      this.$emit("resized");
    },
    toggleDark: function toggleDark() {
      this.displayMode = this.displayMode === "dark" ? "light" : "dark";
      this.switchScheme(true);
    },
    detectScheme: function detectScheme() {
      var storedVal = this.$ls.get("scheme");

      switch (storedVal) {
        case "dark":
        case "light":
          this.displayMode = storedVal;
          break;
        default:
          this.displayMode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["e" /* isDarkMode */])() ? "dark" : "light";
          break;
      }
      if (this.displayMode === "dark") {
        this.switchScheme();
      }
    },
    switchScheme: function switchScheme(store) {
      switch (this.displayMode) {
        case "dark":
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["b" /* addBodyClass */])("dark");
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["a" /* removeBodyClass */])("light");
          break;
        default:
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["b" /* addBodyClass */])("light");
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["a" /* removeBodyClass */])("dark");
          break;
      }
      if (store === true) {
        this.$ls.set("scheme", this.displayMode, 60 * 60 * 1000);
      }
    },
    toggleContactPane: function toggleContactPane(mode) {
      var skip = false;
      if (mode instanceof Object) {
        if (mode.target) {
          if (mode.target.tagName) {
            switch (mode.target.tagName.toLowerCase()) {
              case "a":
                skip = true;
                break;
            }
          }
        }
      }
      console.log(skip, mode);
      if (!skip) {
        switch (mode) {
          case "show":
            this.showContactPane = true;
            break;
          case "hide":
            this.showContactPane = false;
            break;
          default:
            this.showContactPane = !this.showContactPane;
            break;
        }
      }
    }
  }
});

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "contact",
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      apiKey: "9_-Wrj38ow",
      remote: "/mail.php",
      contactName: "",
      subject: "_",
      email: "",
      body: "",
      subjects: [{ key: "_", value: "... Select a subject..." }, { key: "development", value: "Custom Web development" }, { key: "new_service", value: "New Web service" }, { key: "new_feature", value: "New feature for existing site" }, { key: "bug_fix", value: "Fix for my site" }],
      errorMsgs: [],
      showResponse: false,
      responseText: ""
    };
  },
  created: function created() {
    if (window.location.href.indexOf("localhost:") > 0) {
      this.remote = "http://localhost:5444/api/mail.php";
    }
  },

  watch: {
    active: function active(cv, pv) {
      if (cv !== pv) {
        if (!cv) {
          this.showResponse = false;
        }
      }
    }
  },
  computed: {
    error: function error() {
      return this.errorMsgs.length > 0;
    },
    maySubmit: function maySubmit() {
      return this.hasEnteredData && this.validate();
    },
    hasEnteredData: function hasEnteredData() {
      if (this.active) {
        return this.body.trim().length > 4;
      }
      return false;
    },
    subjectLine: function subjectLine() {
      var _this = this;

      var str = "";
      var matched = this.subjects.find(function (s) {
        return s.key === _this.subject;
      });
      if (matched) {
        str = matched.value;
      }
      return str;
    }
  },
  methods: {
    validate: function validate() {
      this.errorMsgs = [];
      if (this.hasEnteredData) {
        if (this.contactName.trim().length < 3) {
          this.errorMsgs.push("Please enter a contact name. (min. 3 characters)");
        }
        if (this.body.trim().length < 10) {
          this.errorMsgs.push("Please enter a message with at least 10 characters");
        }
        this.email = this.email.trim();
        var emailValid = this.email.length > 5 && /[^@]+@\w+/.test(this.email);
        if (!emailValid) {
          this.errorMsgs.push("Please enter a valid email");
        }
        if (this.subject.length < 4) {
          this.errorMsgs.push("Please select a subject");
        }
      }
      return this.errorMsgs.length < 1;
    },
    send: function send() {
      var _this2 = this;

      var key = btoa(this.apiKey.split("").reverse().join(""));
      var params = {
        sec: key,
        fullname: this.contactName.trim(),
        from: this.email,
        subject: this.subjectLine,
        body: this.body
      };
      this.$http.post(this.remote, params).then(function (response) {
        if (response.body) {
          var body = response.body;

          if (body.matched) {
            _this2.contactName = "";
            _this2.email = "";
            _this2.subject = "_";
            _this2.body = "";
            _this2.responseText = body.message;
            _this2.showResponse = true;
          }
        }
      }).catch(function (e) {
        return console.error(e);
      });
    },
    close: function close() {
      this.$parent.toggleContactPane("hide");
    }
  }
});

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils__ = __webpack_require__(15);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CookieCompliance',
  data: function data() {
    return {
      show: false,
      agreed: false,
      disagreed: false,
      notice: "We use cookies and local storage to improve user experience. By accepting cookies you consent to store on your device all the technologies described in our Cookie Policy. You can change your cookie settings at any time by clicking <em>Storage Settings</em>. Please read our Terms and Conditions and Privacy Policy for full details.",
      thankyou: "Thank you for agreeing to a little temporary storage",
      disagreedMessage: "We respect your choice. All temporary storage has been removed."
    };
  },
  created: function created() {
    var _this = this;

    var agreedCookie = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_utils__["f" /* getCookie */])('cookies');
    if (agreedCookie !== 'agreed') {
      setTimeout(function () {
        _this.prompt();
      }, 5000);
    }
  },

  computed: {
    wrapperClasses: function wrapperClasses() {
      var cls = [];
      if (this.show) {
        cls.push('show');
      }
      if (this.agreed) {
        cls.push('agreed');
      } else if (this.disagreed) {
        cls.push('disagreed');
      }
      return cls;
    }
  },
  methods: {
    prompt: function prompt() {
      this.show = true;
    },
    agree: function agree() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_utils__["g" /* setCookie */])('cookies', 'agreed', 7);
      this.agreed = true;
      this.disagreed = false;
      setTimeout(function () {
        _this2.show = false;
      }, 4000);
    },
    disagree: function disagree() {
      var _this3 = this;

      this.disagreed = true;
      this.agreed = false;
      this.$ls.remove('all-panes');
      this.$ls.remove('scheme');
      this.$parent.mayStore = false;
      setTimeout(function () {
        _this3.show = false;
      }, 10000);
    }
  }
});

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_images_loaded__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_images_loaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_images_loaded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils__ = __webpack_require__(15);







function scrollY() {
  if (window.pageYOffset) {
    return window.pageYOffset;
  } else {
    return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
  }
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "home",
  directives: {
    imagesLoaded: __WEBPACK_IMPORTED_MODULE_2_vue_images_loaded___default.a
  },
  data: function data() {
    return {
      backend: "/",
      panes: [],
      numPanes: 0,
      currIndex: 0,
      prevIndex: -1,
      prevIconTs: 0,
      bgClass: "current",
      prevY: 0,
      prevPaneY: 0,
      updating: false,
      updatingDown: false,
      showMenu: false,
      containerClasses: ["menu-collapsed"],
      imgSizes: {
        scale_crop_1024x576: "(max-width: 1024px)",
        scale_crop_1440_810: "(min-width: 1025px) AND (max-width: 1440px)",
        scale_crop_1920x1080: "(min-width: 1441px) AND (max-width: 1920px)",
        scale_crop_2880x1620: "(min-width: 1921px)"
      },
      defSize: {
        width: 1024,
        height: 576,
        name: "scale_crop_1024x576"
      }
    };
  },
  created: function created() {
    this.manageDownArrow();
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("hashchange", this.handlePop);
    this.load();
  },
  mounted: function mounted() {
    var _this = this;

    this.$parent.$on("resized", this.calcOffsetTops);
    this.$parent.$on("escape", function () {
      _this.toggleMenu("hide");
    });
  },
  computed: {
    scrolling: function scrolling() {
      return this.$parent.scrolling;
    },
    currPath: function currPath() {
      return window.location.hash.split("--sect").shift();
    },
    toggleLabel: function toggleLabel() {
      return this.$parent.displayMode === "dark" ? "Light Mode" : "Dark Mode";
    },
    mayStore: function mayStore() {
      return this.$parent.mayStore;
    },
    toggleIcon: function toggleIcon() {
      return this.$parent.displayMode === "dark" ? "icon-sun-fill" : "icon-moon-fill";
    },
    hasItems: function hasItems() {
      var has = false;
      if (this.$parent.items) {
        if (this.$parent.items instanceof Array) {
          return this.$parent.items.length > 0;
        }
      }
      return has;
    }
  },
  methods: {
    load: function load() {
      if (this.hasItems) {
        this.processPanes(this.$parent.items);
      } else {
        setTimeout(this.load, 1000);
      }
    },
    processPanes: function processPanes(items) {
      var _this2 = this;

      this.panes = [];
      items.forEach(function (item, i) {
        _this2.processPane(item, i);
      });
      this.numPanes = this.panes.length;

      setTimeout(function () {
        _this2.$parent.handleResize(true);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["a" /* removeBodyClass */])("loading");
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["b" /* addBodyClass */])("loaded");
      }, 240);
      setTimeout(function () {
        _this2.moveToCurrPane();
        if (SvgMorph) {
          SvgMorph.init();
          setTimeout(_this2.morphIcon, 6000);
        }
      }, 360);
    },
    processPane: function processPane(row, index) {
      if ((typeof row === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(row)) === "object") {
        if (row.title) {
          var pane = {
            title: row.title,
            body: "",
            numImages: 0,
            offsetTop: 0,
            classNames: ["bg-" + (index % 6 + 1)]
          };
          if (index === this.currIndex) {
            pane.classNames.push("active");
          }
          if (row.path) {
            pane.id = row.path.replace(/^\//, "").replace(/\//, "--");
            pane.path = row.path;
          }
          if (row.images) {
            pane.numImages = row.images.length;
            var randIndex = Math.floor(Math.random() * pane.numImages * 0.9999);
            var image = row.images[randIndex];
            if (image.size) {
              image.size.width = this.defSize.width;
              image.size.height = this.defSize.height;
            }
            pane.image = image;
          }
          if (row.body) {
            pane.body = row.body;
          }
          pane.has_sections = false;
          pane.sections = [];
          if (row.has_sections) {
            pane.has_sections = row.has_sections;
            pane.sections = row.sections;
          }
          this.panes.push(pane);
        }
      }
    },

    changeAlias: function changeAlias(tgPath, index) {
      var _this3 = this;

      var paneIndex = this.panes.findIndex(function (p) {
        return p.id === tgPath.substring(1);
      });
      if (paneIndex >= 0) {
        index = paneIndex;
      }

      window.location = tgPath + "--section";

      if (this.panes[this.currIndex].classNames.length > 1) {
        this.panes[this.currIndex].classNames.pop();
      }
      this.prevIndex = this.currIndex;
      if (index < 0) {
        index = 0;
      }
      this.currIndex = index;
      for (var i = 0; i < this.$parent.classNames.length; i++) {
        if (/^bg-\d+/.test(this.$parent.classNames[i])) {
          this.$parent.classNames[i] = this.panes[index].classNames[0];
        }
      }
      this.panes[index].classNames.push("active");
      this.bgClass = "switching";
      setTimeout(function () {
        _this3.bgClass = "current";
      }, 1900);
    },
    moveToPane: function moveToPane(pane, index) {
      var _this4 = this;

      var offsetY = 0;
      this.hideMenu();
      if (pane.offsetTop) {
        offsetY = pane.offsetTop;
      }
      if (offsetY < this.$parent.stopY * 16) {
        offsetY = 0;
      }
      if (offsetY < this.$parent.stopY * 3) {
        this.toggleParentClass("scrolled-down", "rem");
      }
      var tgPath = "#" + pane.path;

      this.toggleMenu("hide");
      var wOfs = 0;
      if (offsetY > this.$parent.halfY) {
        wOfs = this.$parent.winWidth / 50;
        if (wOfs > 32) {
          wOfs = 32;
        }
        wOfs = this.$parent.stopY * 2 + wOfs;
      }

      var ms = 1000;
      if (pane.hasOwnProperty("offsetTop")) {
        var diff = Math.abs(scrollY() - pane.offsetTop);
        ms = Math.pow(diff / this.$parent.winHeight, 0.5) * 1000;
      }
      var target = pane.id;

      this.$parent.scrollTo("#" + target, wOfs, ms);
      this.morphIcon();
      if (tgPath !== this.currPath) {
        setTimeout(function () {
          _this4.changeAlias(tgPath, index);
        }, 1000);
      }
    },
    toNext: function toNext() {
      var nextIndex = this.currIndex + 1;
      if (nextIndex < this.numPanes) {
        var pane = this.panes[nextIndex];
        if (pane.title) {
          this.moveToPane(pane, nextIndex);
        }
      }
    },
    flipBg: function flipBg() {
      var _this5 = this;

      this.bgClass = "switching";
      if (this.prevIndex > -1) {
        setTimeout(function () {
          _this5.toggleContainerClass("flip-x");
          setTimeout(function () {
            _this5.bgClass = "current";
          }, 900);
        }, 100);
      }
    },
    morphIcon: function morphIcon() {
      if (SvgMorph) {
        var currTs = new Date().getTime();
        if (this.prevIconTs < currTs - 3 * 1000) {
          SvgMorph.morphIcon();
          this.prevIconTs = currTs;
        }
      }
    },
    moveToCurrPane: function moveToCurrPane() {
      var currId = this.currPath.replace("#/", "").replace(/\//g, "--");
      var paneIndex = this.panes.findIndex(function (p) {
        return p.id === currId;
      });
      if (paneIndex >= 0) {
        this.moveToPane(this.panes[paneIndex], paneIndex);
      }
    },
    manageDownArrow: function manageDownArrow() {
      var _this6 = this;

      if (!this.updatingDown) {
        this.updatingDown = true;
        if (this.panes.length > 1) {
          var lastOffset = this.panes[this.panes.length - 1].offsetTop;
          var md = scrollY() > lastOffset - this.$parent.halfY ? "rem" : "add";
          this.toggleParentClass("show-down", md);
          this.removeContainerClass("hide-arrow");
          if (md === "add") {
            setTimeout(function () {
              _this6.addContainerClass("hide-arrow");
            }, 5000);
          }
          setTimeout(function () {
            _this6.updatingDown = false;
          }, 1100);
        }
      }
    },
    handleScroll: function handleScroll() {
      var _this7 = this;

      var sy = scrollY();
      if (sy > this.prevY + this.$parent.stopY || scrollY() < this.prevY - this.$parent.stopY) {
        this.manageDownArrow();
        if (scrollY() > this.$parent.stopY * 6) {
          this.toggleParentClass("scrolled-down", "add");
        } else {
          this.toggleParentClass("scrolled-down", "rem");
        }
        if (this.numPanes > 0 && this.updating === false) {
          var isLast = sy > this.panes[this.numPanes - 1].offsetTop - this.$parent.stopY;
          var start = isLast ? this.numPanes - 1 : 0;
          var pn = null;
          var sTop = sy - this.$parent.winHeight / 2;
          var paneIndex = this.panes.findIndex(function (pn) {
            return pn.offsetTop >= sTop;
          });
          if (paneIndex >= 0) {
            var pane = this.panes[paneIndex];
            this.moveToInnerSection(pane, paneIndex, isLast);
          }
        }
        this.prevY = sy;
        if (this.containerClasses.indexOf("moving") < 0) {
          setTimeout(function () {
            _this7.removeContainerClass("moving");
          }, 500);
        }
        this.addContainerClass("moving");
      }
    },
    moveToInnerSection: function moveToInnerSection(pane, paneIndex, isLast) {
      var _this8 = this;

      var index = paneIndex > 0 && !isLast ? paneIndex - 1 : paneIndex;
      var tgPath = "#" + pane.path;
      if (tgPath !== this.currPath) {
        this.updating = true;
        this.prevPaneY = scrollY();

        this.changeAlias(tgPath, index);
        setTimeout(function () {
          _this8.updating = false;
        }, 250);
        this.morphIcon();
      }
    },
    handlePop: function handlePop(e) {
      if (e.oldURl !== e.newURL) {
        var path = window.location.hash.replace(/^#/, "").split("--").shift();
        if (path.length > 0) {
          if (this.scrolling === false) {
            if (path !== this.currPath) {
              var index = this.panes.findIndex(function (pane) {
                return pane.path === path;
              });
              if (index >= 0) {
                this.moveToPane(this.panes[index], index);
              }
            }
          }
        }
      }
    },
    calcOffsetTops: function calcOffsetTops() {
      for (var i = 0; i < this.numPanes; i++) {
        var elem = document.getElementById(this.panes[i].id);
        if (elem) {
          this.panes[i].offsetTop = elem.offsetTop;
        }
      }
    },
    hideMenu: function hideMenu() {
      this.toggleMenu("hide");
    },
    toggleMenu: function toggleMenu(mode) {
      switch (mode) {
        case "hide":
          this.showMenu = true;
          break;
        case "show":
          this.showMenu = false;
          break;
      }
      if (this.showMenu) {
        this.removeContainerClass("menu-expanded");
        this.addContainerClass("menu-collapsed");
        this.toggleParentClass("show-menu", "rem");
        this.showMenu = false;
      } else {
        this.removeContainerClass("menu-collapsed");
        this.addContainerClass("menu-expanded");
        this.toggleParentClass("show-menu", "add");
        this.showMenu = true;
      }
    },

    addContainerClass: function addContainerClass(clsName) {
      this.toggleContainerClass(clsName, "add");
    },
    removeContainerClass: function removeContainerClass(clsName) {
      this.toggleContainerClass(clsName, "rem");
    },
    toggleParentClass: function toggleParentClass(clsName, mode) {
      this.toggleContainerClass(clsName, mode, true);
    },
    toggleContainerClass: function toggleContainerClass(clsName, mode, parent) {
      var cls = [];
      if (parent === true) {
        cls = this.$parent.extraClasses;
      } else {
        cls = this.containerClasses;
      }
      var index = cls.indexOf(clsName);
      if (!mode) {
        mode = index < 0 ? "add" : "rem";
      }
      if (mode === "add" && index < 0) {
        cls.push(clsName);
      } else if (index >= 0) {
        switch (mode) {
          case "rem":
          case "remove":
            cls.splice(index, 1);
            break;
        }
      }
    },
    toggleContactPane: function toggleContactPane(mode) {
      this.$parent.toggleContactPane(mode);
    },
    toggleDark: function toggleDark() {
      this.$parent.toggleDark();
    }
  }
});

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MainLogo'
});

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TopIcons'
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ls__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_ls__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

var options = {
  namespace: 'vuejs__'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_ls___default.a, options);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload___default.a, {
  preLoad: 1,
  error: '/static/images/loading-wheel.svg',
  loading: '/static/images/loading-wheel.svg',
  attempt: 3
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('vue-lazypic', {
  props: {
    imgset: {},
    sizes: {},
    className: '',
    imgClass: ''
  },
  template: '<picture :class="className"><template v-for="(img,key) in imgset.uris"><source v-if="sizes[key]" :data-srcset="img" :media="sizes[key]"></template><img v-lazy="imgset.uris.scale_crop_1024x576" :width="imgset.size.width" :height="imgset.size.height" :class="imgClass" /></picture>'
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(95),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(94),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(91),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 91:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticStyle: {
      "background-color": "#ffffff00"
    },
    attrs: {
      "id": "icon",
      "viewBox": "0 0 48 48",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "earth_asia"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23.374,0c-4.232,0-8.197,1.13-11.621,3.097l1.152,0.687h3.729l1.267,0.94l0.402,0.031l0.951-0.961l1.051,0.035   l1.396,0.208l0.88,0.445l9.404,0.485l2.578,1.091L34.2,6.367l-1.911-0.309l-0.03,0.37l0.698,0.481l-0.91,0.182v0.546l-1.881,0.122   l1.426,1.334l0.242,1.092l-0.64,0.333l-2-1.637V8.122l0.484-0.758l-0.363-0.455L27.13,8.365l-1.729-0.152l-0.576-0.424   l-0.729,1.032l0.334,0.667l2.518,0.303l1.011,1.153l-0.253,0.334l-0.787-0.79l-0.365,0.394l0.617,0.813l-0.133,1.528l-1.616-0.002   l-0.081,1.233l1.365,0.829l0.475,0.627l-0.718,0.192l-2.548-1.942h-0.819l0.03,1.578l1.852,1.941l0.142,1.407l-0.933,0.777   l-2.121,0.759l0.211,0.789l-0.386,0.273l-0.433-0.667l0.061-0.516l-0.758-0.243l-0.426,0.576l0.06,1.093l1.496,1.204l0.15,0.909   l-0.905,0.603l-0.689-0.072l-1.234-1.4l-0.242,0.973l2.336,3.336l-0.152,0.484l-2.883-2.76v-2.791l-2.183-1.941l-1.74-0.167   l-0.987,0.368l-0.611,1.315l-0.325,2.443l-0.591,0.856l-0.593-0.138L9.407,22.13l0.107-1.114v-0.819L8.676,19.67l-3.58-0.585   l-1.65-0.081l-1.444-0.83L1.9,17.303H1.214c0,0-0.02,1.195-0.02,1.26s3.115,1.533,3.115,1.533l0.888,0.116l0.015,0.667   l-0.833,0.546l-2.661,1.927l-1.274,0.082l-0.435-0.437c-0.001,0.126-0.008,0.251-0.008,0.377c0,0.237,0.01,0.474,0.018,0.71   l0.234,0.117l2.599-0.547l0.485,0.223l-2.502,3.577l-0.403,0.385c2.085,10.772,11.561,18.909,22.942,18.909   c5.874,0,11.238-2.172,15.344-5.75l-0.336,0.148l-0.756,0.496l-2.669,1.637l-1.101,0.168v-0.5l0.358-0.295l2.104-1.496l1.313-0.182   l0.708-0.484l0.102-1.549l0.807-0.049l0.014,0.991l0.438-0.087l0.109,0.193c4.283-4.237,6.938-10.116,6.938-16.616   C46.747,10.465,36.282,0,23.374,0z M13.187,25.738l-0.92,0.343l-0.254-0.688l0.534-0.752l0.741,0.146L13.187,25.738z M30.157,27.68   l0.646,0.385l-0.052,0.705l0.677-0.018l0.729-0.385l2.608,1.184l0.101,1.404h0.547v0.466h-1.092v-1.153l-0.628,0.062l-0.588,0.626   l-1.616,0.104l-0.021-0.75h0.484l-0.02-0.365l-0.75-0.393l-1.334-0.191l-0.617-0.758L30.157,27.68z M27.28,30.938l0.049-0.281   l0.554-0.082l0.046,0.43l-0.342-0.038v0.25h-0.484v0.212h-0.471v-0.424h0.03L27.28,30.938z M26.903,30.734l-0.317-0.1v-0.219h0.409   L26.903,30.734z M26.729,27.896l0.016,1.971l-0.443,0.041v-0.667l-0.426-0.152l0.081,0.942h-0.546v-1.479h0.264l-0.014-0.238   L26.729,27.896z M26.382,30.503v0.231l-0.22,0.033v0.236h-0.304v0.189l-0.447,0.046v-0.235l0.287-0.27l0.197-0.231H26.382z    M22.043,27.2l2.116-1.147l0.281-0.25l0.233-0.631h0.365l0.121,0.623l0.25,0.104v1.998l-0.25,0.164v0.267l-0.402,0.364   l-0.228,0.576h-1.782l-0.706-0.934L22.043,27.2L22.043,27.2z M25.161,30.734v0.27h-0.486v-0.27H25.161z M20.226,30.127h0.566   v-0.203l-0.426-0.142l-2.972-3.642l0.507-0.404l2.085,1.879l-0.024,0.306l0.445,0.586l1.618-0.021l0.062,0.748L21.5,29.296   l-0.243-0.103l0.061,0.81l1.498-0.041l1.212,0.771l-3.661-0.16L20.226,30.127z M31.474,42.357l-0.85,0.47l-1.055-0.115l0.992-1.097   l0.93,0.102L31.474,42.357z M35.03,38.471l-2.871,2.7l-2.979-0.103l-0.973-2.137l-2.623,0.105l-3.236,1.111v-0.586l0.668-0.647   l0.081-3.315l1.112-0.77l0.997-0.012l1.88-2.144l1.188-0.09v0.444h0.404l0.992-1.407h1.38l1.175,0.706l-0.552,0.539l-0.655-0.135   l0.045,0.887l0.345,0.208l1.235,0.092l0.264-2.233l0.646,0.029l0.719,1.232l0.082,1.781l1.09,0.933l0.295,1.194L35.03,38.471z",
      "id": "dark-solid"
    }
  })]), _vm._v(" "), _c('g', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "earth_west"
    }
  }, [_c('path', {
    attrs: {
      "d": "M40.503,16.351l0.4,0.287h0.373V15.92l1.176-0.114l1.117,0.832h1.836l0.129-0.118c-0.184-0.619-0.391-1.227-0.623-1.823   l-1.198,0.02l-0.601-0.66l-0.116-1.061l-0.616,0.336l-0.33,1.297l-0.889-0.946l-0.036-0.894l-0.858-0.739l-0.316-0.315h-0.995   l0.313,0.887l1.198,0.668l0.208,0.221l-0.26,0.13l0.012,0.703l-0.584,0.244l-0.498-0.109l-0.312-0.441l0.811,0.043l0.219-0.295   l-1.795-1.211l-0.138-0.516l-0.729,0.66l-0.739-0.152l-1.125,1.463l-0.222,0.573l-0.72,0.065l-1.065,0.007l-0.637-0.298   l-0.188-1.265l0.229-0.603l1.084-0.237l1.182,0.237l0.145-0.654l-0.502-0.119l0.171-1.019l1.19-0.186l0.832-1.175l0.859-0.144   l0.775,0.115h0.286l-0.158-1.104l-0.942,0.38l-0.332-0.825l-0.547-0.076l-0.103-0.565l0.446-0.486l1.061-0.416l0.273-0.488   C34.599,2.175,29.284,0,23.468,0c-5.047,0-9.716,1.638-13.513,4.405l1.16-0.009l0.517,0.286l0.974,0.21l0.076,0.383l1.549,0.057   l-0.21-0.497l-1.376-0.039l0.324-0.305l-0.113-0.364h-1.244l1.357-1.013h1.3l0.611,0.842l1.014,0.057l0.611-0.593l0.459,0.229   l-0.842,0.822c0,0-1.165,0.021-1.108,0.021c0.057,0,0.096,0.802,0.096,0.802l1.413-0.039l0.153-0.381l0.974-0.058l0.115-0.573   l-0.573-0.097l0.191-0.516l0.439-0.133l1.529,0.076l-0.843,0.765l0.136,0.592l0.879,0.134l-0.057-1.07l0.841-0.44l1.491-0.172   l2.159,0.956v0.822l0.688,0.172l-0.345,0.65h-0.975l-0.289,0.745l-2.225-0.525l1.751-0.933l-0.667-0.567l-1.51,0.191l-0.132,0.137   l-0.005-0.002L20.225,5.06L19.79,5.512l-0.719,0.059l0.057,0.358l0.251,0.104l-0.01,0.118l-0.585,0.083l-0.043,0.339l-0.559,0.029   l-0.101-0.674l-1.003,0.305l-2.05,1.2l0.23,0.845l0.573,0.374l1.146,0.158v1.303l0.53-0.085l0.488-1.018l1.219-0.386V7.061   l0.678-0.512l1.639,0.387l-0.115,1.033h0.44l1.205-0.592l0.058,1.356l0.877,0.535l-0.037,0.804l-0.84,0.286l0.057,0.266   l1.013,0.461l-0.021,0.554l-0.293,0.025c-0.001-0.009-0.003-0.015-0.003-0.015l-1.278-0.394l-0.054-0.41h-0.001l0.374-0.257v-0.374   l-0.402-0.101l-0.1,0.345l-0.705,0.109l-0.07-0.023v0.035l-0.244,0.037l-0.199-0.402l-0.23-0.101h-0.502l-0.228,0.188v0.416   l0.429,0.143l0.424,0.06l-0.095,0.042l-0.387,0.429l-0.17-0.214l-0.374-0.099l-1.019,0.958l0.133,0.109l-1.504,0.833l-1.415,1.472   l-0.097,0.655l-1.418,0.932l-0.703,0.707l0.078,1.414l-0.975-0.454l0.007-0.827l-2.713,0.001l-1.405,0.711l-0.61,1.125   l-0.242,0.892l0.395,0.865l1.107,0.135l1.759-1.176l0.154,0.583l-0.537,1.014l1.339,0.229l0.134,2.068l1.835,0.312l1.166-1.348   l1.415,0.288l0.497,0.691l1.357-0.08l0.038-0.401l0.746,0.362l0.841,1.318l1.452,0.02l0.536,0.938l0.076,1.146l1.606,0.611   l2.026,0.021l0.593,0.973l0.898,0.288l-0.172,0.805l-0.984,1.25l-0.287,2.769l-0.889,0.702l-1.318-0.039l-0.439,0.764l0.326,1.436   l-1.435,1.834l-0.458,0.842l-1.367,0.656l-0.899,0.137l-0.037,0.381l0.631,0.181l-0.076,0.411l-0.565,0.544l0.343,0.433l0.68,0.019   l-0.038,0.524l-0.181,0.517l-0.058,0.42l1.006,0.847l-0.134,0.44l-1.369-0.026l-1.362-1.188l-1.061-1.865l0.148-1.8l-0.803-1.071   l0.325-1.815l-0.477-0.133v-3.938c0,0-1.338-1.014-1.415-1.014c-0.077,0-0.708-0.172-0.708-0.172l-0.134-0.744l-1.739-2.18   l0.172-0.783l0.057-1.281l1.204-0.842l-0.172-1.434l-1.758-0.132l-1.376-1.568L9.816,22.08l-0.63-0.116l0.076-0.573l-0.803-0.114   v0.325l-2.008-0.501l-0.808-1.236l0.329-0.599l-1.271-1.855l-0.218-1.357H3.967l0.171,1.318l0.879,1.357l-0.096,0.536L4.176,19.15   l-0.917-1.563v-1.819l-0.956-0.459V14c-1.18,2.766-1.835,5.808-1.835,9.001c0,12.683,10.318,23.001,23.001,23.001   c7.19,0,13.618-3.318,17.839-8.502h-0.759v-1.529l-0.878-1.182V32.95l-0.67-0.668l-0.059-0.765l0.852-1.625l-1.613-2.849   l0.189-1.933l-1.452-0.15l-0.535-0.535h-0.976l-0.496,0.458H33.19l-0.058,0.153h-0.957l-2.196-2.503l0.018-1.95l0.363-0.133   l0.135-0.746h-0.516l-0.211-0.783l2.541-1.834v-1.3l1.244-0.691l0.504,0.05h1.023l0.801-0.43l2.581-0.201v1.319L40.503,16.351z    M34.051,8.15l0.21-0.324l0.756-0.153l0.189,0.918l0.402,0.649l0.267,0.307l0.487,0.19l-0.459,0.546l-0.889,0.085h-0.668   l0.075-0.793l0.556-0.115l-0.047-0.373l-0.518-0.325L34.05,8.514L34.051,8.15L34.051,8.15z M32.81,9.584l0.459-0.736l0.619-0.144   l0.44,0.191l-0.04,0.497l-0.946,0.669h-0.534V9.584H32.81z M20.313,12.413l-0.479,0.04l0.026-0.333l0.214-0.267l0.288,0.226   L20.313,12.413z M21.992,11.825l-0.327,0.028l-0.066,0.316l-0.252,0.157l-0.404,0.034c-0.014-0.095-0.022-0.167-0.022-0.167h-0.157   v-0.34h0.659l0.136-0.351l0.262-0.005l0.299,0.062L21.992,11.825z"
    }
  })]), _vm._v(" "), _c('g', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "globe_simple"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 45.12553,14.339558 C 42.647501,8.5622784 38.436557,4.3606272 32.611046,1.8760704 29.699405,0.6342912 26.67479,0 23.487898,0 20.301619,0 17.273702,0.6283008 14.365286,1.8760704 8.5880832,4.3540224 4.332672,8.5529856 1.8502656,14.339558 0.606336,17.238605 0,20.275814 0,23.462093 c 0,3.186893 0.606336,6.249293 1.8502656,9.148953 2.4824064,5.786573 6.7377408,10.010727 12.5150204,12.489293 2.908416,1.24777 5.936256,1.875456 9.122612,1.875456 3.186892,0 6.211507,-0.634291 9.123148,-1.875456 5.825588,-2.484633 10.036532,-6.71255 12.514484,-12.489293 1.247769,-2.908953 1.87607,-5.96206 1.87607,-9.148953 0,-3.186279 -0.628301,-6.213658 -1.87607,-9.122535 z M 15.675571,4.3688448 C 13.64544,6.9384192 12.155366,10.202035 11.204198,14.159693 l -6.1417724,0 C 7.3238016,9.76512 11.127475,6.2443776 15.675571,4.3688448 Z M 2.8524288,23.462093 c 0,-2.235648 0.3596544,-4.394035 1.053696,-6.475699 l 6.7328252,0 c -0.333926,2.184115 -0.488448,4.343116 -0.488448,6.475699 0,2.107392 0.154599,4.240665 0.488448,6.424781 l -6.784358,0 C 3.1863552,27.80521 2.8524288,25.646822 2.8524288,23.462093 Z m 2.2099968,9.251481 6.1418494,0 c 0.951168,4.034381 2.441319,7.34953 4.471373,9.893914 C 11.050138,40.679885 7.2465408,37.159219 5.0624256,32.713574 Z M 22.048819,43.892045 C 20.378342,43.404058 18.810931,42.170573 17.397658,40.166246 15.984307,38.161382 14.904883,35.669069 14.15977,32.713574 l 7.889049,0 0,11.178471 z m 0,-14.005171 -8.531635,0 c -0.334387,-2.287258 -0.514253,-4.420455 -0.514253,-6.424781 0,-2.158387 0.179789,-4.317312 0.565786,-6.475699 l 8.480025,0 0,12.90048 7.7e-5,0 z m 0,-15.727104 -7.889049,0 c 0.796569,-2.929767 1.88206,-5.3924356 3.28942,-7.3754116 1.419341,-2.0004864 2.929229,-3.237888 4.599706,-3.700608 l 0,11.0760196 z m 19.890432,0 -6.141926,0 C 34.846694,10.202035 33.356083,6.9384192 31.325952,4.3689216 35.874662,6.2443776 39.677798,9.76512 41.939251,14.15977 Z M 24.952781,3.0837504 c 1.670477,0.46272 3.180288,1.7001216 4.599705,3.700608 1.407821,1.982976 2.492775,4.4456446 3.289344,7.3754116 l -7.889049,0 0,-11.0760196 z m 0,13.9026436 8.480025,0 c 0.38592,2.158387 0.565786,4.317312 0.565786,6.475699 0,2.004403 -0.179866,4.137523 -0.514253,6.424781 l -8.531558,0 0,-12.90048 z m 0,26.905651 0,-11.178471 7.889049,0 c -0.770764,2.955495 -1.864473,5.437901 -3.263616,7.452672 -1.402368,2.019687 -2.929228,3.263616 -4.625433,3.725799 z m 6.373248,-1.284557 c 2.030131,-2.544384 3.520742,-5.859533 4.471373,-9.893914 l 6.141926,0 c -2.184192,4.445645 -5.987942,7.966311 -10.613299,9.893914 z m 11.820979,-12.720614 -6.784358,0 c 0.334387,-2.184192 0.488448,-4.317389 0.488448,-6.424781 0,-2.132583 -0.154061,-4.291507 -0.488448,-6.475699 l 6.732825,0 c 0.694042,2.081587 1.053696,4.239974 1.053696,6.475699 -7.7e-5,2.184729 -0.333849,4.343117 -1.002163,6.424781 z"
    }
  })]), _vm._v(" "), _c('g', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "laptop_tablet"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22.264,29.031H5.089L0,29.287v3.502h32.616v-3.758h-9.347H22.264z M27.768,31.34H17.17v-0.703h10.598V31.34z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.196,21.033V42.07h12.507V21.033H34.196z M40.727,21.903c0.168,0,0.303,0.135,0.303,0.302     c0,0.166-0.135,0.303-0.303,0.303c-0.166,0-0.301-0.137-0.301-0.303C40.426,22.039,40.561,21.903,40.727,21.903z M38.928,22.914     h3.598v0.289h-3.598V22.914z M40.609,41.162c-0.398,0-0.721-0.322-0.721-0.722c0-0.397,0.321-0.721,0.721-0.721     c0.396,0,0.721,0.323,0.721,0.721S41.006,41.162,40.609,41.162z M44.696,38.685c-3.248,0.019-6.884,0.03-8.493,0.017V24.236     l8.493-0.002V38.685z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m 7.74,7.282 30.061,0 0,12.098 2.648,0 0,-14.747 -35.359,0 0,23.316 27.527,0 0,-2.649 -24.877,0 z"
    }
  })]), _vm._v(" "), _c('g', {
    staticStyle: {
      "display": "none",
      "transform": "scale(0.9)"
    },
    attrs: {
      "id": "data_storage"
    }
  }, [_c('path', {
    attrs: {
      "d": "m 22.865998,46.733519 c 11.634278,0 21.067776,-2.676326 21.067776,-5.971968 l 0,-7.531315 c -0.13824,0.105062 -0.27648,0.204595 -0.425725,0.304128 -1.255274,0.840499 -2.985984,1.575936 -5.142528,2.189777 -4.169373,1.177749 -9.671325,1.830242 -15.499523,1.830242 -5.828199,0 -11.330151,-0.652493 -15.4994692,-1.830297 C 5.2099848,35.110244 3.47922,34.374863 2.2240008,33.534308 2.0747016,33.434775 1.9364616,33.335243 1.7982216,33.23018 l 0,7.531371 c 0,3.295642 9.4335524,5.971968 21.0677764,5.971968 z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m 22.865998,35.342543 c 11.241677,0 20.426342,-2.493849 21.034598,-5.640192 0.02212,-0.110592 0.03318,-0.221184 0.03318,-0.331776 l 0,-7.586611 c -0.13824,0.105062 -0.27648,0.204595 -0.425725,0.304128 -1.056153,0.707789 -2.455142,1.343693 -4.163843,1.891123 -0.315133,0.09953 -0.641434,0.199066 -0.978685,0.298599 -0.337305,0.09395 -0.680195,0.18795 -1.03409,0.27648 -0.818326,0.204539 -1.675414,0.387072 -2.571264,0.55296 -3.522355,0.652492 -7.619734,1.000857 -11.894169,1.000857 -4.274381,0 -8.371815,-0.348365 -11.899699,-1.000857 C 10.070503,24.941366 9.2134152,24.753359 8.3950344,24.554294 8.04114,24.465762 7.6983048,24.377346 7.3609992,24.277814 7.0236936,24.18381 6.6974472,24.084278 6.38226,23.979215 4.6736136,23.431785 3.2746248,22.795881 2.2184712,22.088092 2.069172,21.988559 1.930932,21.889026 1.792692,21.783964 l 0,7.586611 c 0,0.110592 0.011059,0.221184 0.033178,0.331776 0.6138409,3.146343 9.7985064,5.640192 21.0401284,5.640192 z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m 10.966299,22.851177 c 1.144627,0.221184 2.366668,0.41472 3.65512,0.569604 2.532557,0.304128 5.31942,0.475546 8.244634,0.475546 2.925158,0 5.712076,-0.171418 8.244578,-0.475546 1.288397,-0.154884 2.510439,-0.34842 3.655121,-0.569604 5.208828,-1.011917 8.736768,-2.670797 9.134844,-4.56745 0.02765,-0.121651 0.03865,-0.237773 0.03865,-0.359424 l 0,-10.7274238 c 0,-3.2956416 -9.433498,-5.971968 -21.067776,-5.971968 -11.634223,0 -21.067776,2.6763264 -21.067776,5.971968 l 0,10.7274238 c 0,0.121651 0.011059,0.237773 0.038707,0.359424 0.3926569,1.896653 3.9150674,3.555533 9.1238958,4.56745 z m 14.166835,-4.578509 c 0,1.249745 -1.017447,2.267136 -2.267136,2.267136 -1.24969,0 -2.267136,-1.017391 -2.267136,-2.267136 0,-1.24969 1.017446,-2.267136 2.267136,-2.267136 1.249689,0 2.267136,1.017446 2.267136,2.267136 z"
    }
  })]), _vm._v(" "), _c('g', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "account_balance"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 4 44 L 42 44 L 42 38 L 4 38 L 4 44 L 4 44 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M 32 20 L 32 34 L 38 34 L 38 20 L 32 20 L 32 20 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M 20 20 L 20 34 L 26 34 L 26 20 L 20 20 L 20 20 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M 8 20 L 8 34 L 14 34 L 14 20 L 8 20 L 8 20 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M 23 2 L 4 12 L 4 16 L 42 16 L 42 12 L 23 2 L 23 2 Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "dolphin"
    }
  }, [_c('path', {
    attrs: {
      "d": "m 14.758765,0.00198591 c 2.438994,-0.04346 4.235276,0.627451 7.665873,1.90875599 2.632999,0.983551 3.91255,1.120355 5.394268,1.278054 1.182121,0.125858 2.404821,0.255838 4.419811,0.820696 5.72004,1.603316 8.34583,3.878573 9.99477,5.681708 1.45364,1.5895261 1.26883,3.0404241 1.02538,3.7705031 4.22328,2.230602 4.31459,2.753258 4.3542,2.980656 0.0627,0.360526 -0.0794,0.763773 -0.39958,1.134578 -0.36077,0.41769 -1.0184,0.855158 -1.79662,0.836856 -0.46382,-0.01203 -1.30405,-0.214576 -2.36758,-0.471558 -1.19565,-0.288822 -2.68336,-0.648319 -3.86647,-0.774177 -1.63917,-0.174747 -3.09806,0.140169 -5.3076,0.615523 -0.6155,0.132376 -1.31313,0.282433 -2.07329,0.433363 -2.66885,0.530259 -4.973373,0.159501 -5.976982,-0.06464 -0.225892,0.733588 -0.878382,2.140736 -2.73141,4.569653 -2.907529,3.811605 -5.944605,3.879679 -6.07247,3.880682 -0.186782,0.0048 -0.363515,-0.10427 -0.450011,-0.272752 -0.0865,-0.168479 -0.07068,-0.371507 0.04113,-0.524442 0.01003,-0.01404 1.015081,-1.41027 1.412713,-3.708314 0.274783,-1.587772 0.07418,-2.868235 -0.07198,-3.496774 -1.089854,0.265004 -3.944651,1.071755 -6.177259,2.697133 -2.5748324,1.874589 -4.2289454,6.354906 -4.7258604,9.963435 -0.304618,2.21155 -0.07141,3.54968 0.656166,3.76805 0.197312,0.0594 0.406874,0.0498 0.753611,0.0338 0.582409,-0.0273 1.462445,-0.0677 3.0594934,0.21056 2.706206,0.47159 4.425226,2.47871 4.497181,2.56395 0.129118,0.15318 0.153653,0.36844 0.06415,0.54745 -0.08925,0.17926 -0.27635,0.28872 -0.477923,0.27618 -0.007,0 -0.715064,-0.0361 -2.328408,0.22917 -0.950958,0.15644 -1.49131,0.44901 -2.013547,0.73207 -0.360025,0.19505 -0.731944,0.39709 -1.196768,0.52395 -0.7290764,0.19856 -1.5595894,0.23526 -2.0517404,0.23651 -0.09978,0.35426 -0.299055,0.8793 -0.691422,1.4607 -0.493906,0.73209 -1.436338,1.22183 -2.434179,1.74031 -0.445268,0.23166 -0.905715,0.47077 -1.300088,0.72374 -0.916861,0.58843 -2.006499,2.65393 -2.348974,3.40031 -0.08198,0.17901 -0.26059398,0.29234 -0.45539898,0.29234 -0.01229,0 -0.02491,-2.2e-4 -0.03819,-0.002 -0.209095,-0.0158 -0.386711,-0.1598 -0.444626,-0.36138 -0.01931,-0.0669 -0.470139,-1.66887 -0.227699,-3.92279 0.179261,-1.667 0.98808898,-3.11668 1.70162398,-4.39582 0.273278,-0.48965 0.53141,-0.9519 0.735492,-1.39215 0.57263,-1.23477 0.345233,-2.83279 0.125357,-4.37819 -0.04237,-0.29785 -0.08435,-0.59374 -0.12095,-0.88582 -0.0188,-0.14818 -0.04388,-0.32904 -0.07296,-0.53914 C 0.77393662,19.974814 4.2606266,11.968368 13.887148,5.3918179 14.762496,5.0079369 14.386232,4.3622299 13.605586,3.8204489 12.39564,2.9559869 9.6961606,2.4078639 9.6690826,2.4023479 c -0.162462,-0.03259 -0.298166,-0.14284 -0.36285,-0.295274 -0.06468,-0.152434 -0.05008,-0.326775 0.03917,-0.466171 0.07296,-0.114075 0.7924914,-1.12244299 3.5942204,-1.49400099 0.659253,-0.08744 1.2563,-0.135404 1.819145,-0.145434 z M 40.027987,10.707277 a 0.72510667,1.2652179 70.342802 0 0 -0.20174,0.01665 0.72510667,1.2652179 70.342802 0 0 -1.38334,0.952419 0.72510667,1.2652179 70.342802 0 0 1.02147,0.622868 0.72510667,1.2652179 70.342802 0 0 1.38382,-0.95242 0.72510667,1.2652179 70.342802 0 0 -0.82021,-0.639516 z"
    }
  })]), _vm._v(" "), _c('g', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "pigeon"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 47.894398,7.2309165 C 47.217937,6.979554 44.968544,6.0592605 44.427074,4.7701377 l -0.0088,-0.021221 C 43.821531,3.3279521 42.423978,-4.6040001e-8 38.527311,-4.6040001e-8 33.543186,-4.6040001e-8 32.107709,4.61242 31.870585,5.5370946 31.466571,7.1127652 30.626094,10.390472 23.243621,15.544225 c -2.133159,1.489145 -6.181519,5.034781 -9.845306,8.624637 -2.462695,2.412998 -6.5469256,6.607987 -6.2310796,7.611931 0.031078,0.09871 0.129104,0.257934 0.437557,0.257934 0,0 1.369e-4,0 2.738e-4,0 0.2977742,0 0.762302,-0.144301 1.4102861,-0.451522 C 8.701423,31.872384 8.2834438,32.250249 7.8349342,32.648924 4.0705204,35.995359 0.05022604,39.666676 5.2855284e-4,40.874886 -0.00494775,41.007139 0.03215423,41.115981 0.11073924,41.198262 c 0.27354157,0.286548 0.56926218,0.425783 0.90413836,0.425783 0.3684186,0 0.7379325,-0.167575 1.1290777,-0.345007 0.4626111,-0.209743 0.9409666,-0.426605 1.5006452,-0.426605 0.1280087,0 0.2569758,0.01177 0.3836154,0.03505 l 0.037376,0.0033 c 0.3046196,-4.1e-4 1.7439301,-0.860875 5.2035875,-2.973635 3.2801718,-2.003096 7.7726598,-4.746452 8.5033368,-4.746452 0.01438,0 0.02108,0.0015 0.02149,0.0015 l 0,0 c 0.49766,0.201802 4.368177,1.142768 8.770991,1.142768 0.224255,0 0.445224,-0.0029 0.663866,-0.0078 0.981217,0.891269 2.23228,2.001728 2.731582,2.33455 0.237946,0.158676 0.442349,0.326525 0.639907,0.488898 0.16689,0.137044 0.337751,0.277512 0.527094,0.410312 -0.223981,0.07708 -0.465897,0.166343 -0.722462,0.266833 -0.279976,0.109663 -0.418663,0.426741 -0.309,0.706991 0.08256,0.210428 0.28203,0.346514 0.507927,0.346651 l 0,0 c 0.03916,0 0.04847,0 1.135102,-0.373074 0.390598,-0.134032 0.82925,-0.284768 0.938365,-0.317899 0.23644,0.04107 0.486022,0.06188 0.742587,0.06188 0.978206,0 1.794586,-0.294899 1.995841,-0.373895 0.198927,0.05901 1.015581,0.31078 1.526794,0.604447 0.111032,0.0638 0.207826,0.04176 0.256292,-0.0356 0.03847,-0.06147 0.03299,-0.144163 -0.01643,-0.245749 l -0.358699,-0.502862 c 0.09022,0.0053 0.180992,0.009 0.273268,0.009 0.978206,0 1.794586,-0.294899 1.995841,-0.373895 0.198926,0.05901 1.015718,0.310781 1.526794,0.604311 0.04504,0.02588 0.08365,0.03792 0.121574,0.03792 0.05559,0 0.105967,-0.02752 0.134717,-0.07338 0.03847,-0.06147 0.03299,-0.144301 -0.01643,-0.245887 l -0.390734,-0.547904 c -0.01177,-0.01588 -0.296953,-0.391282 -0.884424,-0.580763 -0.205361,-0.06626 -0.451658,-0.101311 -0.712331,-0.101311 -0.389502,0 -0.636073,0.05531 -0.853619,0.10405 -0.171135,0.03833 -0.318995,0.07146 -0.510255,0.07146 l 0,0 c -0.23466,0 -0.514499,-0.0512 -0.880727,-0.161003 -0.7916,-0.237398 -2.573043,-1.864135 -3.736211,-2.986915 0.94877,-0.316805 1.792122,-0.716712 2.521703,-1.202871 5.318453,-3.544129 5.567077,-8.590958 5.715759,-11.60635 0.02902,-0.590072 0.05421,-1.099779 0.115139,-1.483531 0.154843,-0.975604 0.303798,-2.196684 0.447962,-3.377376 0.198106,-1.623178 0.385122,-3.15627 0.561322,-3.844094 0.529148,-2.0664849 2.34249,-3.5261947 5.389508,-4.3387418 0.291203,-0.077627 0.351716,-0.093782 0.357192,-0.2064568 0.0031,-0.061609 -0.03464,-0.1177406 -0.105419,-0.1440269 z M 31.074878,33.913267 c 0.951508,0.861697 2.091812,1.868516 2.562912,2.182582 0.236439,0.157581 0.439747,0.326799 0.63621,0.490541 0.161961,0.134717 0.321048,0.267243 0.494373,0.391419 -0.166069,0.02067 -0.301881,0.05066 -0.427015,0.07872 -0.171271,0.03847 -0.319268,0.07174 -0.510802,0.07174 -0.234386,0 -0.513952,-0.0512 -0.879769,-0.160866 -0.749022,-0.224666 -2.384384,-1.692727 -3.543445,-2.800995 0.580626,-0.06407 1.137703,-0.147586 1.667536,-0.253142 z"
    }
  })]), _vm._v(" "), _c('g', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "history"
    }
  }, [_c('path', {
    attrs: {
      "d": "M25,4c-7.1,0-13.2,3.8-16.4,9.5L4,9v13h13l-5.5-5.5C13.9,11.5,19,8,25,8c8.3,0,15,6.7,15,15\n      c0,8.3-6.7,15-15,15c-6.5,0-12.1-4.2-14.1-10H6.7c2.2,8.1,9.5,14,18.3,14c10.5,0,19-8.5,19-19S35.5,4,25,4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22,14v10.2l9.4,5.6\n      l1.5-2.6l-8-4.7V14H22z"
    }
  })]), _vm._v(" "), _c('g', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "home"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "20,40 20,28 28,28 28,40 38,40 38,24 44,24 24,6 4,24 10,24 10,40"
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classNames,
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    attrs: {
      "id": "top-header"
    },
    on: {
      "click": function($event) {
        _vm.topAnim()
      }
    }
  }, [_c('main-logo')], 1), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer', {
    attrs: {
      "id": "bottom-footer"
    }
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "title": "Contact Neil"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.footer)
    },
    on: {
      "click": _vm.toggleContactPane
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reload",
    on: {
      "click": _vm.reload
    }
  }, [_c('i', {
    staticClass: "icon-chevron-up"
  })])]), _vm._v(" "), _c('aside', {
    attrs: {
      "id": "vector-pane"
    }
  }, [_c('top-icons')], 1), _vm._v(" "), _c('aside', {
    staticClass: "fixed-pane",
    attrs: {
      "id": "contact-pane"
    }
  }, [_c('contact', {
    attrs: {
      "active": _vm.showContactPane
    }
  })], 1), _vm._v(" "), _c('cookie-compliance')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close icon-cross-circle",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), (!_vm.showResponse) ? _c('form', {
    staticClass: "contact-form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.send($event)
      }
    }
  }, [_c('label', {
    staticClass: "small",
    attrs: {
      "for": "contact-subject-field"
    }
  }, [_vm._v("Subject")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    attrs: {
      "name": "subject",
      "id": "contact-subject-field"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.subject = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.subjects), function(subOpt, si) {
    return _c('option', {
      key: [subOpt.key, si].join('_'),
      domProps: {
        "value": subOpt.key
      }
    }, [_vm._v(_vm._s(subOpt.value))])
  })), _vm._v(" "), _c('label', {
    staticClass: "small",
    attrs: {
      "for": "contact-name-field"
    }
  }, [_vm._v("Contact name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactName),
      expression: "contactName"
    }],
    staticClass: "textfield plain-text",
    attrs: {
      "type": "text",
      "maxlength": "255",
      "size": "64",
      "required": "true",
      "placeholder": "Your name / organisation",
      "id": "contact-name-field"
    },
    domProps: {
      "value": (_vm.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "small",
    attrs: {
      "for": "contact-email-field"
    }
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "textfield mail",
    attrs: {
      "type": "email",
      "maxlength": "255",
      "size": "64",
      "placeholder": "Contact email address",
      "id": "contact-email-field"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "small",
    attrs: {
      "for": "contact-body-field"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body),
      expression: "body"
    }],
    staticClass: "textfield multi-line",
    attrs: {
      "rows": "6",
      "cols": "64",
      "placeholder": "Write a message...",
      "id": "contact-body-field"
    },
    domProps: {
      "value": (_vm.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.body = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.error) ? _c('ul', {
    staticClass: "error messages"
  }, _vm._l((_vm.errorMsgs), function(msg, eri) {
    return _c('li', {
      key: ['error-msg', eri].join('_')
    }, [_vm._v(_vm._s(msg))])
  })) : _vm._e(), _vm._v(" "), (_vm.maySubmit) ? _c('button', {
    staticClass: "button submit",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "icon-send"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Send")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showResponse) ? _c('div', {
    staticClass: "response",
    domProps: {
      "innerHTML": _vm._s(_vm.responseText)
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "full",
    attrs: {
      "id": "main-logo",
      "viewBox": "0 0 540 45",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "m 97.758294,494.51145 -9.9,0.7 0,-14.3 0,-0.8 -0.05,-0.95 q 0,-1.9 -1.9,-1.9 -0.3,0.05 -0.45,0.05 -1.75,0.25 -1.75,2.65 l -0.1,0.9 0,0.75 0,12.9 -9.9,0.7 0,-14.25 0,-0.75 0,-0.35 0,-0.45 q 0,-0.85 -0.45,-1.45 -0.45,-0.6 -0.85,-0.65 -0.4,-0.1 -0.6,-0.1 -0.2,0 -0.3,0 -1.95,0 -1.95,2.75 l -0.05,0.75 -0.05,0.95 0,12.85 -9.9,0.7 0,-26.25 9.9,-0.7 0,3.85 q 0.75,-1.45 1.95,-2.5 2.15,-1.7 4.7,-1.7 0.3,0 0.7,0.05 0.45,0.05 1.45,0.2 1.05,0.1 2.2,0.9 1.15,0.8 2.1,2.4 l 0.35,0.9 0.55,-0.85 q 1.5,-2 2.95,-2.8 1.45,-0.8 3.6,-0.8 3.95,0 5.85,2.5 1.9,2.45 1.9,8.25 l 0,1.6 0,1.2 0,13.05 z",
      "fill": "rgba(255,0,0,1)",
      "transform": "rotate(360 78.65829400000001 481.5614499999999)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 178.22861,466.21145 -0.65,-0.1 q -1.95,0 -2.5,0.35 -0.5,0.3 -0.75,0.7 -0.25,0.4 -0.35,1.15 l -0.05,0.55 0,0.45 3.4,0 0,7.35 -3.4,0 0,17.75 -10.5,0.8 0,-18.55 -2.45,0 0.85,-7.35 1.6,0 0,-0.4 0,-0.45 0,-0.3 0.2,-1.7 q 0.75,-3.85 3.55,-6.1 2.85,-2.3 6.9,-2.3 1.05,0 2.1,0.15 l 0.4,0.1 0.2,0 1.45,7.9 z",
      "fill": "rgba(0,204,0,1)",
      "transform": "rotate(360 169.60361 476.63644999999997)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 354.69111,469.16145 -6.8,25.7 -9.35,0 -2.85,-14.25 -2.9,14.25 -9.35,0 -6.8,-25.7 9.6,-1.1 3.1,15 3,-14.45 6.6,0 3.05,14.45 3.1,-15 9.6,1.1 z",
      "fill": "rgba(0,0,204,1)",
      "transform": "rotate(360 335.66611 481.46145)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 435.25908,486.26145 q 0.05,0.35 0.05,1.05 0,3.65 -3.2,6.05 -3.2,2.35 -9.1,2.35 -1.15,0 -2.45,-0.1 -1.3,-0.1 -3.45,-0.45 l -1.9,-0.35 -0.9,-0.15 1.15,-8.15 0.65,0.2 0.7,0.15 0.8,0.15 1.05,0.1 q 1.05,0.15 1.85,0.15 0.8,0 1.85,-0.25 1.1,-0.25 1.35,-0.75 0.25,-0.55 0.25,-0.75 0,-0.3 -0.15,-0.45 l -0.25,-0.2 -0.95,-0.4 -1.05,-0.35 q -3.8,-1.05 -5.55,-2.85 -1.7,-1.85 -1.7,-4.65 0,-0.65 0.15,-1.9 0.15,-1.25 1.35,-2.8 1.2,-1.55 3.1,-2.45 1.9,-0.9 3.75,-1.25 1.85,-0.35 4.5,-0.35 1.3,0 2.45,0.15 1.2,0.15 3.5,0.65 l 1.1,0.3 -1.2,7.8 -0.6,-0.1 -0.55,-0.1 -0.8,-0.05 -0.9,-0.05 -0.75,-0.1 -0.8,0 -0.5,0 -0.5,0 -0.45,0 q -1.6,0.2 -1.75,0.95 l 0,0.3 q 0,0.5 0.1,0.65 0.1,0.15 0.65,0.4 l 0.35,0.15 1.15,0.4 q 4.15,1.35 5.75,2.85 1.6,1.45 1.85,4.2 z",
      "fill": "rgba(153,0,153,1)",
      "transform": "rotate(360 424.80908 481.78645000000006)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 122.00111,494.58145 -7.84,0.56 0,-2.52 -0.24,0.32 q -1,1.24 -2.2,1.76 -1.2,0.52 -3.16,0.52 -3.44,0 -5.24,-2.28 -1.8,-2.32 -1.8,-7.16 l 0,-0.6 0,-11.04 8.4,-0.56 0,10.92 0,1.12 0.04,0.6 q 0,0.64 0.44,1.08 0.48,0.44 1.16,0.44 0.36,0 0.88,-0.16 0.56,-0.2 0.72,-0.56 0.2,-0.36 0.28,-0.64 0.12,-0.32 0.12,-0.4 l 0,-0.84 0.04,-1.28 0,-9.72 8.4,-0.56 0,21 z",
      "transform": "rotate(0 111.76111000000002 484.40144999999995)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 133.74923,494.58145 -8.4,0.56 0,-29.12 8.4,-0.56 0,29.12 z",
      "transform": "rotate(0 129.54923000000002 480.30145000000005)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 149.22611,474.42145 -1.12,5.88 -2.32,0 0,5 0,0.52 0,0.44 q 0.24,1.8 2.28,1.8 0.44,0 0.64,-0.04 l 0.36,-0.04 -1.36,7.2 -0.16,0 -0.52,0.04 -1.8,-0.08 q -4.4,-0.4 -6.12,-2.44 -1.72,-2.08 -1.72,-6.84 l 0,-0.56 0,-5 -1.92,0 0.92,-5.88 1,0 0,-2.8 8.4,-3.36 0,6.16 3.44,0 z",
      "transform": "rotate(0 142.34611 481.74145)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 159.74173,468.26145 -4.88,4.76 -4.92,-4.76 4.92,-4.76 4.88,4.76 z m -0.68,26.24 -8.4,0.64 0,-21 8.4,-0.56 0,20.92 z",
      "transform": "rotate(0 154.84172999999998 479.32145)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 199.58486,494.86145 -7.84,0 0,-2.68 -0.52,0.56 q -2.6,2.48 -5.56,2.48 -0.76,0 -3.6,-0.68 -2.84,-0.68 -3.4,-3.44 -0.52,-2.76 -0.52,-3.6 0,-3.96 2.52,-5.36 2.56,-1.4 4.32,-1.4 1.2,0 2.36,0.36 1.2,0.36 2.48,1.16 l 0.8,0.52 0,-1.24 0,-0.24 q 0,-0.6 -0.68,-1.68 -0.64,-1.08 -4.12,-1.08 l -0.96,0.08 -0.6,0.08 q -1.4,0.12 -2.92,0.44 l -0.92,0.24 1.4,-5.52 1.76,-0.32 q 2.76,-0.44 5.36,-0.44 5.4,0 8,2.2 2.64,2.16 2.64,6.12 l 0,1.24 0,12.2 z m -8.84,-5.92 q 0.2,-0.28 0.32,-0.6 0.12,-0.32 0.12,-0.64 0,-0.28 -0.12,-0.6 -0.12,-0.32 -0.56,-0.96 -0.44,-0.64 -1.92,-0.64 -0.36,0 -1,0.12 -0.64,0.12 -1.08,0.84 -0.44,0.68 -0.44,1.24 0,0.64 0.56,1.44 0.56,0.76 2,0.76 0.32,0 0.96,-0.12 0.68,-0.12 1.16,-0.84 z",
      "transform": "rotate(0 188.86485999999996 484.16145)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 222.40736,475.98145 -4.72,6.12 q -1.16,-1.08 -2.92,-1.08 -1.28,0 -2.24,0.76 -0.92,0.72 -1.12,1.52 -0.2,0.76 -0.2,1.2 0,1.44 1.04,2.4 1.08,0.92 2.76,0.92 0.72,0 1.44,-0.24 0.72,-0.28 1.28,-0.76 l 4.64,6.32 -1.84,0.96 q -3.12,1.36 -6.24,1.36 -4.56,0 -7.88,-2.56 -3.32,-2.56 -3.72,-5.04 -0.36,-2.48 -0.36,-3.6 0,-6.48 4.16,-8.68 4.16,-2.2 7.56,-2.2 0.64,0 1.28,0.04 0.68,0.04 1.52,0.2 0.84,0.12 1.8,0.48 0.96,0.36 2.2,1 l 1,0.52 0.56,0.36 z",
      "transform": "rotate(0 212.36736 484.42144999999994)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 244.53923,480.30145 -10.68,7.68 1.08,0.36 q 0.6,0.12 1.2,0.12 1.08,0 2.2,-0.4 1.12,-0.4 2.16,-1.04 l 0.28,-0.2 0.24,-0.16 3.48,5.8 q -1.44,1.12 -3.28,1.84 -1.84,0.72 -3.2,0.92 -1.36,0.2 -1.84,0.2 -0.44,0 -0.72,0 -3.52,0 -6.32,-1.64 -2.8,-1.68 -4.2,-4.08 -1.4,-2.4 -1.4,-5.36 0,-0.84 0.36,-3.2 0.4,-2.4 2.84,-4.8 2.44,-2.44 4.52,-2.68 2.12,-0.24 2.44,-0.24 0.36,-0.04 0.56,-0.04 2.92,0 5.4,1.52 2.52,1.48 3.56,3.2 1.04,1.72 1.32,2.2 z m -7.88,0.48 q -0.68,-0.8 -1.52,-0.92 -0.84,-0.16 -1.12,-0.16 -1.44,0 -2.36,0.96 -0.88,0.92 -0.88,2.44 0,0.24 0.04,0.52 0.04,0.24 0.04,0.4 l 0.2,0.8 5.6,-4.04 z",
      "transform": "rotate(0 234.03923000000003 484.40144999999995)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 258.60111,474.42145 -1.12,5.88 -2.32,0 0,5 0,0.52 0,0.44 q 0.24,1.8 2.28,1.8 0.44,0 0.64,-0.04 l 0.36,-0.04 -1.36,7.2 -0.16,0 -0.52,0.04 -1.8,-0.08 q -4.4,-0.4 -6.12,-2.44 -1.72,-2.08 -1.72,-6.84 l 0,-0.56 0,-5 -1.92,0 0.92,-5.88 1,0 0,-2.8 8.4,-3.36 0,6.16 3.44,0 z",
      "transform": "rotate(0 251.72110999999998 481.74145)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 280.47673,480.30145 -10.68,7.68 1.08,0.36 q 0.6,0.12 1.2,0.12 1.08,0 2.2,-0.4 1.12,-0.4 2.16,-1.04 l 0.28,-0.2 0.24,-0.16 3.48,5.8 q -1.44,1.12 -3.28,1.84 -1.84,0.72 -3.2,0.92 -1.36,0.2 -1.84,0.2 -0.44,0 -0.72,0 -3.52,0 -6.32,-1.64 -2.8,-1.68 -4.2,-4.08 -1.4,-2.4 -1.4,-5.36 0,-0.84 0.36,-3.2 0.4,-2.4 2.84,-4.8 2.44,-2.44 4.52,-2.68 2.12,-0.24 2.44,-0.24 0.36,-0.04 0.56,-0.04 2.92,0 5.4,1.52 2.52,1.48 3.56,3.2 1.04,1.72 1.32,2.2 z m -7.88,0.48 q -0.68,-0.8 -1.52,-0.92 -0.84,-0.16 -1.12,-0.16 -1.44,0 -2.36,0.96 -0.88,0.92 -0.88,2.44 0,0.24 0.04,0.52 0.04,0.24 0.04,0.4 l 0.2,0.8 5.6,-4.04 z",
      "transform": "rotate(0 269.97673 484.40144999999995)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 304.41861,494.58145 -7.84,0.56 0,-2.52 q -0.24,0.32 -0.48,0.6 -0.2,0.24 -1.16,1.16 -0.92,0.88 -3.72,0.88 -2.48,0 -4.76,-1.36 -2.24,-1.4 -3.28,-3.6 -1,-2.2 -1.24,-4.52 0,-0.8 0.16,-2.8 0.2,-2.04 0.8,-4.04 0.64,-2.04 3,-3.68 2.36,-1.68 5.28,-1.68 2.48,0 4.84,1.08 l 0,-8.64 8.4,-0.56 0,29.12 z m -8.2,-10.4 q 0,-1.56 -0.88,-2.48 -0.88,-0.92 -2.32,-0.92 -1.36,0 -2.28,0.96 -0.88,0.92 -0.88,2.44 0,1.24 0.72,2.16 0.72,0.92 1.36,1.08 0.64,0.12 0.8,0.12 0.2,0 0.4,0 1.32,0 2.2,-0.92 0.88,-0.92 0.88,-2.44 z",
      "transform": "rotate(0 293.17861 480.36145000000005)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 376.0822,480.30145 -10.68,7.68 1.08,0.36 q 0.6,0.12 1.2,0.12 1.08,0 2.2,-0.4 1.12,-0.4 2.16,-1.04 l 0.28,-0.2 0.24,-0.16 3.48,5.8 q -1.44,1.12 -3.28,1.84 -1.84,0.72 -3.2,0.92 -1.36,0.2 -1.84,0.2 -0.44,0 -0.72,0 -3.52,0 -6.32,-1.64 -2.8,-1.68 -4.2,-4.08 -1.4,-2.4 -1.4,-5.36 0,-0.84 0.36,-3.2 0.4,-2.4 2.84,-4.8 2.44,-2.44 4.52,-2.68 2.12,-0.24 2.44,-0.24 0.36,-0.04 0.56,-0.04 2.92,0 5.4,1.52 2.52,1.48 3.56,3.2 1.04,1.72 1.32,2.2 z m -7.88,0.48 q -0.68,-0.8 -1.52,-0.92 -0.84,-0.16 -1.12,-0.16 -1.44,0 -2.36,0.96 -0.88,0.92 -0.88,2.44 0,0.24 0.04,0.52 0.04,0.24 0.04,0.4 l 0.2,0.8 5.6,-4.04 z",
      "transform": "rotate(0 365.58220000000006 484.40144999999995)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 400.86408,483.46145 q 0,3.16 -1,5.44 -0.96,2.24 -3.6,4.28 -2.6,2.04 -6.6,2.04 -1,0 -3.88,-0.44 -2.84,-0.48 -5.28,-3.36 -2.44,-2.88 -2.44,-7.76 -0.08,-0.36 -0.08,-0.68 0,-0.36 0,-0.72 0.04,-0.36 0.08,-0.68 l 0,-15.56 8.4,-0.56 0,8.88 0.44,-0.28 q 1.08,-0.52 2.2,-0.72 1.12,-0.24 2.48,-0.24 3.92,0 6.6,2.88 2.68,2.88 2.68,7.48 z m -8.12,0.6 q 0,-1.56 -0.88,-2.48 -0.88,-0.92 -2.28,-0.92 -1.36,0 -2.28,0.96 -0.88,0.92 -0.88,2.44 0,1.24 0.68,2.16 0.68,0.92 1.44,1.08 0.8,0.12 1.08,0.12 1.32,0 2.2,-0.92 0.92,-0.96 0.92,-2.44 z",
      "transform": "rotate(0 389.42408 480.34145)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 458.62126,480.30145 -10.68,7.68 1.08,0.36 q 0.6,0.12 1.2,0.12 1.08,0 2.2,-0.4 1.12,-0.4 2.16,-1.04 l 0.28,-0.2 0.24,-0.16 3.48,5.8 q -1.44,1.12 -3.28,1.84 -1.84,0.72 -3.2,0.92 -1.36,0.2 -1.84,0.2 -0.44,0 -0.72,0 -3.52,0 -6.32,-1.64 -2.8,-1.68 -4.2,-4.08 -1.4,-2.4 -1.4,-5.36 0,-0.84 0.36,-3.2 0.4,-2.4 2.84,-4.8 2.44,-2.44 4.52,-2.68 2.12,-0.24 2.44,-0.24 0.36,-0.04 0.56,-0.04 2.92,0 5.4,1.52 2.52,1.48 3.56,3.2 1.04,1.72 1.32,2.2 z m -7.88,0.48 q -0.68,-0.8 -1.52,-0.92 -0.84,-0.16 -1.12,-0.16 -1.44,0 -2.36,0.96 -0.88,0.92 -0.88,2.44 0,0.24 0.04,0.52 0.04,0.24 0.04,0.4 l 0.2,0.8 5.6,-4.04 z",
      "transform": "rotate(0 448.12126 484.40144999999995)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 475.36314,473.58145 -1.4,7.4 -0.56,-0.04 q -1.72,0 -2.64,0.68 -0.88,0.64 -1.36,2.2 -0.4,0.92 -0.4,2.32 l 0,0.68 0,7.76 -8.4,0.56 0,-21 7.84,-0.56 0,3.8 0.32,-0.56 q 0.92,-1.52 1.68,-2.2 0.76,-0.72 1.64,-1 0.92,-0.32 1.64,-0.32 0.24,0 0.48,0 0.32,0.08 0.48,0.08 l 0.68,0.2 z",
      "transform": "rotate(0 467.98314000000005 484.22145)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 496.12751,474.30145 -5.72,20.56 -9.84,0 -5.72,-20.56 7.76,-0.88 2.92,15.04 2.88,-15.04 7.72,0.88 z",
      "transform": "rotate(0 485.48750999999993 484.14144999999996)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 506.40189,468.26145 -4.88,4.76 -4.92,-4.76 4.92,-4.76 4.88,4.76 z m -0.68,26.24 -8.4,0.64 0,-21 8.4,-0.56 0,20.92 z",
      "transform": "rotate(0 501.50189 479.32145)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 528.59876,475.98145 -4.72,6.12 q -1.16,-1.08 -2.92,-1.08 -1.28,0 -2.24,0.76 -0.92,0.72 -1.12,1.52 -0.2,0.76 -0.2,1.2 0,1.44 1.04,2.4 1.08,0.92 2.76,0.92 0.72,0 1.44,-0.24 0.72,-0.28 1.28,-0.76 l 4.64,6.32 -1.84,0.96 q -3.12,1.36 -6.24,1.36 -4.56,0 -7.88,-2.56 -3.32,-2.56 -3.72,-5.04 -0.36,-2.48 -0.36,-3.6 0,-6.48 4.16,-8.68 4.16,-2.2 7.56,-2.2 0.64,0 1.28,0.04 0.68,0.04 1.52,0.2 0.84,0.12 1.8,0.48 0.96,0.36 2.2,1 l 1,0.52 0.56,0.36 z",
      "transform": "rotate(0 518.5587599999999 484.42144999999994)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 550.73064,480.30145 -10.68,7.68 1.08,0.36 q 0.6,0.12 1.2,0.12 1.08,0 2.2,-0.4 1.12,-0.4 2.16,-1.04 l 0.28,-0.2 0.24,-0.16 3.48,5.8 q -1.44,1.12 -3.28,1.84 -1.84,0.72 -3.2,0.92 -1.36,0.2 -1.84,0.2 -0.44,0 -0.72,0 -3.52,0 -6.32,-1.64 -2.8,-1.68 -4.2,-4.08 -1.4,-2.4 -1.4,-5.36 0,-0.84 0.36,-3.2 0.4,-2.4 2.84,-4.8 2.44,-2.44 4.52,-2.68 2.12,-0.24 2.44,-0.24 0.36,-0.04 0.56,-0.04 2.92,0 5.4,1.52 2.52,1.48 3.56,3.2 1.04,1.72 1.32,2.2 z m -7.88,0.48 q -0.68,-0.8 -1.52,-0.92 -0.84,-0.16 -1.12,-0.16 -1.44,0 -2.36,0.96 -0.88,0.92 -0.88,2.44 0,0.24 0.04,0.52 0.04,0.24 0.04,0.4 l 0.2,0.8 5.6,-4.04 z",
      "transform": "rotate(0 540.23064 484.40144999999995)"
    }
  }), _c('path', {
    attrs: {
      "d": "m 568.63251,487.98145 q 0.04,0.28 0.04,0.84 0,2.92 -2.56,4.84 -2.56,1.88 -7.28,1.88 -0.92,0 -1.96,-0.08 -1.04,-0.08 -2.76,-0.36 l -1.52,-0.28 -0.72,-0.12 0.92,-6.52 0.52,0.16 0.56,0.12 0.64,0.12 0.84,0.08 q 0.84,0.12 1.48,0.12 0.64,0 1.48,-0.2 0.88,-0.2 1.08,-0.6 0.2,-0.44 0.2,-0.6 0,-0.24 -0.12,-0.36 l -0.2,-0.16 -0.76,-0.32 -0.84,-0.28 q -3.04,-0.84 -4.44,-2.28 -1.36,-1.48 -1.36,-3.72 0,-0.52 0.12,-1.52 0.12,-1 1.08,-2.24 0.96,-1.24 2.48,-1.96 1.52,-0.72 3,-1 1.48,-0.28 3.6,-0.28 1.04,0 1.96,0.12 0.96,0.12 2.8,0.52 l 0.88,0.24 -0.96,6.24 -0.48,-0.08 -0.44,-0.08 -0.64,-0.04 -0.72,-0.04 -0.6,-0.08 -0.64,0 -0.4,0 -0.4,0 -0.36,0 q -1.28,0.16 -1.4,0.76 l 0,0.24 q 0,0.4 0.08,0.52 0.08,0.12 0.52,0.32 l 0.28,0.12 0.92,0.32 q 3.32,1.08 4.6,2.28 1.28,1.16 1.48,3.36 z",
      "transform": "rotate(0 560.27251 484.40144999999995)"
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.numPanes > 0) ? _c('div', {
    staticClass: "main",
    class: _vm.containerClasses
  }, [_c('nav', {
    attrs: {
      "id": "side-nav"
    }
  }, [_c('ul', {
    staticClass: "menu"
  }, [_vm._l((_vm.panes), function(pane, index) {
    return _c('li', {
      key: ['nav-item', index].join('-'),
      class: {
        'active': index === _vm.currIndex
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moveToPane(pane, index)
        }
      }
    }, [_vm._v(_vm._s(pane.title))])
  }), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleContactPane($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-envelope-closed contact"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('li', {
    staticClass: "toggle-dark",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.toggleDark($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.toggleIcon
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.toggleLabel))])])], 2), _vm._v(" "), _c('button', {
    staticClass: "menu-toggle icon-list",
    on: {
      "click": function($event) {
        _vm.toggleMenu()
      }
    }
  })]), _vm._v(" "), (_vm.panes[_vm.currIndex].numImages > 0) ? _c('figure', {
    class: _vm.bgClass,
    attrs: {
      "id": "background-picture"
    },
    on: {
      "click": function($event) {
        _vm.flipBg()
      }
    }
  }, [(_vm.prevIndex > -1) ? _c('vue-lazypic', {
    attrs: {
      "imgset": _vm.panes[_vm.prevIndex].image,
      "sizes": _vm.imgSizes,
      "imgClass": "prev-bg"
    }
  }) : _vm._e(), _vm._v(" "), _c('vue-lazypic', {
    attrs: {
      "imgset": _vm.panes[_vm.currIndex].image,
      "sizes": _vm.imgSizes,
      "imgClass": "curr-bg"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "panes-container",
    attrs: {
      "id": "main-content"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('ul', {
    staticClass: "panes"
  }, _vm._l((_vm.panes), function(pane, index) {
    return _c('li', {
      key: ['section', index, pane.id].join('-'),
      staticClass: "pane",
      class: pane.classNames,
      attrs: {
        "id": pane.id,
        "data-top": pane.offsetTop
      }
    }, [_c('article', [_c('h2', [_vm._v(_vm._s(pane.title))]), _vm._v(" "), _c('div', {
      staticClass: "body",
      domProps: {
        "innerHTML": _vm._s(pane.body)
      }
    }), _vm._v(" "), (pane.has_sections) ? _vm._l((pane.sections), function(section, subindex) {
      return _c('div', {
        key: ['subsection', pane.id, subindex].join('-'),
        staticClass: "sub-section",
        class: 'sub-section-' + subindex
      }, [(section.has_title) ? _c('h3', [_vm._v(_vm._s(section.title))]) : _vm._e(), _vm._v(" "), (section.has_body) ? _c('div', {
        staticClass: "sub-body",
        domProps: {
          "innerHTML": _vm._s(section.body)
        }
      }) : _vm._e()])
    }) : _vm._e()], 2)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-down",
    attrs: {
      "id": "scroll-down"
    },
    on: {
      "click": function($event) {
        _vm.toNext()
      }
    }
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "fixed-pane",
    class: _vm.wrapperClasses,
    attrs: {
      "id": "cookie-overlay"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [(!_vm.agreed) ? _c('div', [_c('p', {
    staticClass: "message",
    domProps: {
      "innerHTML": _vm._s(_vm.notice)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "agree",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.agree($event)
      }
    }
  }, [_vm._v("Agree")]), _vm._v(" "), _c('button', {
    staticClass: "disagree",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.disagree($event)
      }
    }
  }, [_vm._v("Disagree")])]) : _vm._e(), _vm._v(" "), (_vm.agreed) ? _c('p', {
    staticClass: "message",
    domProps: {
      "innerHTML": _vm._s(_vm.thankyou)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.disagreed) ? _c('p', {
    staticClass: "message",
    domProps: {
      "innerHTML": _vm._s(_vm.disagreedMessage)
    }
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ })

},[51]);


// WEBPACK FOOTER //
// static/js/app.7c468f66d6f442d0b75e.js